import React, { useMemo } from 'react'
import { IgrReportData } from '../typesExtendedReport'
import { useMappedExtendedData } from '../useMappedExtendedData'
import { safeNum } from '../utils/extendedUtils'


export const useIgrMappedData = (
    data: IgrReportData | null | undefined,
    palette: string[]
) => {
    const base = useMappedExtendedData(data, palette)

    return useMemo(() => {
        if (!data || !base) return null

        return {
            ...base,
            approved: data.approvedprojects,
            fields: {
                projectTotalCount: safeNum(data.projectTotalCount),
                operationTotalCount: safeNum(data.operationTotalCount),
                averageAge: safeNum(data.averageAge),
                idbApprovedAmount_Original: safeNum(data.idbApprovedAmount_Original),
                idbApprovedAmount_Current: safeNum(data.idbApprovedAmount_Current),
                disbursementPercent: safeNum(data.disbursementPercent),
                disbursementAmount: safeNum(data.disbursementAmount),
                withoutDisbursingAmount: safeNum(data.withoutDisbursingAmount),
                projectionsDisbursementsYearPercent: safeNum(data.projectionsDisbursementsYearPercent),
                projectionsDisbursementsYearAmount: safeNum(data.projectionsDisbursementsYearAmount),
                projectionsWithoutDisbursementsYearAmount: safeNum(data.projectionsWithoutDisbursementsYearAmount),
                projectionsWithoutDisbursementsYearPercent: safeNum(data.projectionsWithoutDisbursementsYearPercent),
            }
        }
    }, [data, base])
}
